import gatewayService from '@/modules/common/services/gatewayService';

const BASE_PATH = 'business/subscriptionsmng/v1';

const buildQueryParams = (filterPrams = {}) => {
  const queryParams = new URLSearchParams({
    page: '1',
    per_page: '50',
  });

  Object.keys(filterPrams).forEach((key) => {
    if (filterPrams[key]) {
      queryParams.append(`filter[${key}]`, filterPrams[key]);
    }
  });

  return queryParams.toString();
};

// eslint-disable-next-line camelcase
const fetchPurchasable = async ({ uid, purchasable_type, item_uid, display_name }) => {
  try {
    const queryString = buildQueryParams({ uid, purchasable_type, item_uid, display_name });
    const response = await gatewayService.get(`${BASE_PATH}/purchasables?${queryString}`);
    const responseData = response?.data?.data?.purchasables?.[0];

    return responseData.prices.reduce((acc, obj) => {
      acc[obj.currency] = {
        ...obj,
        display_name: responseData.display_name,
        item_uid: responseData.item_uid,
        item_type: responseData.item_type,
      };

      return acc;
    }, {});
  } catch (error) {
    console.error('Error fetching purchasable data:', error);
    return { code: 'error', message: error.message || 'An unknown error occurred.' };
  }
};

export default {
  fetchPurchasable,
};
